// src/customers/CustomerDashboard.jsx
import React from 'react';

function CustomerDashboard() {
  return (
    <div className="container mt-5">
      <h3>📊 Welcome to Customer Dashboard</h3>
      <p>This will include your client-facing features.</p>
    </div>
  );
}

export default CustomerDashboard;
